/**
 * 아이폰 HEIF/HEIC 사진을 JPEG 로 바꾼다. 웹뷰가 HEIF 를 못 그리는 기기가 있다.
 * (StoreReview 안에 같은 함수가 있다. 그쪽은 건드리지 않고, 새로 쓰는 곳은 이걸 쓴다.)
 */
export const isHeifFile = (file: File): boolean => {
  const lowerName = file.name.toLowerCase()
  if (lowerName.endsWith('.heic') || lowerName.endsWith('.heif')) return true
  return ['image/heic', 'image/heif', 'image/heic-sequence', 'image/heif-sequence'].includes(
    (file.type || '').toLowerCase()
  )
}

export const toJpegIfHeif = async (file: File): Promise<File> => {
  if (!isHeifFile(file)) return file
  const heic2any = (await import('heic2any')).default
  const converted = await heic2any({ blob: file, toType: 'image/jpeg', quality: 0.92 })
  const blob = Array.isArray(converted) ? converted[0] : converted
  if (!blob || blob.size === 0) throw new Error('HEIF 이미지를 변환할 수 없습니다')
  return new File([blob], file.name.replace(/\.(heic|heif)$/i, '.jpg'), { type: 'image/jpeg' })
}
